
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/SEO';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Om Os - Passion for Heste og Kvalitetsudstyr"
        description="EquiNord forbinder hesteelskere med det fineste udstyr siden 2020. Læs om vores mission, værdier og hvorfor vi er din pålidelige kilde til hesteudstyr."
        keywords="om equinord, om os, hesteudstyr forhandler, affiliate hesteudstyr, pålidelig hesteudstyr"
      />
      <Header />
      <main>
      
      {/* Hero Section */}
      <section className="relative h-96 bg-cover bg-center" style={{
        backgroundImage: `url('/images/home-hero.jpg')`
      }}>
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Om EquiNord</h1>
            <p className="text-xl md:text-2xl max-w-2xl">
              Forbinder hesteelskere med det fineste nordiske udstyr siden 2020
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Our Story */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Vores Historie</h2>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-lg text-gray-700 mb-6">
                  EquiNord blev født af en passion for heste og en dyb forståelse af, hvad ryttere og hesteejere virkelig har brug for. Grundlagt af erfarne ryttere, erkendte vi udfordringen ved at finde højkvalitets, pålidelig udstyr fra pålidelige brands på ét sted.
                </p>
                <p className="text-lg text-gray-700 mb-6">
                  I stedet for at vedligeholde vores eget lager, har vi indgået partnerskaber med branchens mest respekterede producenter og forhandlere for at bringe dig omhyggeligt kuraterede udvalg af det fineste hesteudstyr tilgængeligt.
                </p>
                <p className="text-lg text-gray-700">
                  Hvert produkt vi fremhæver er blevet personligt testet eller kommer højt anbefalet af vores team af professionelle ryttere, trænere og hesteplejeksperter.
                </p>
              </div>
              <div className="relative aspect-[5/4]">
                <img 
                  src="/images/home-trust.jpg"
                  alt="Vores rideteam"
                  width="500"
                  height="400"
                  className="rounded-lg shadow-lg w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Our Mission */}
          <div className="mb-16 bg-emerald-50 rounded-2xl p-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Vores Mission</h2>
            <div className="text-center max-w-3xl mx-auto">
              <p className="text-lg text-gray-700 mb-6">
                At gøre premium hesteudstyr tilgængeligt for ryttere på alle niveauer ved at forbinde dem direkte med pålidelige brands og forhandlere, samtidig med at vi giver ekspert vejledning og ærlige anmeldelser.
              </p>
              <div className="grid md:grid-cols-3 gap-8 mt-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-2xl text-white"></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">Kvalitet Sikret</h3>
                  <p className="text-gray-600">Hvert produkt er omhyggeligt kontrolleret af vores ekspertteam</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-heart-line text-2xl text-white"></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">Hest-Først</h3>
                  <p className="text-gray-600">Vi prioriterer din hests komfort og sikkerhed</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-group-line text-2xl text-white"></i>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">Fællesskabsdrevet</h3>
                  <p className="text-gray-600">Bygget af ryttere, for ridefællesskabet</p>
                </div>
              </div>
            </div>
          </div>

          {/* Affiliate Transparency */}
          <div className="bg-blue-50 rounded-2xl p-8 mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Vores Affiliate Model</h2>
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-lg text-gray-700 mb-6">
                Gennemsigtighed er kernen i alt hvad vi gør. EquiNord fungerer som affiliate partner med omhyggeligt udvalgte hesteforhandlere og producenter.
              </p>
              <div className="grid md:grid-cols-2 gap-8 text-left">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                    <i className="ri-check-line text-emerald-600 mr-2"></i>
                    Hvad Dette Betyder for Dig
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>• Ingen ekstra omkostninger for dig</li>
                    <li>• Adgang til eksklusive tilbud og rabatter</li>
                    <li>• Direkte support fra autoriserede forhandlere</li>
                    <li>• Fuld producentgaranti</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                    <i className="ri-heart-line text-blue-600 mr-2"></i>
                    Vores Forpligtelse
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>• Ærlige, upartiske produktanmeldelser</li>
                    <li>• Anbefaler kun produkter vi stoler på</li>
                    <li>• Klar oplysning om alle partnerskaber</li>
                    <li>• Din tilfredshed er vores prioritet</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Team Values */}
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Hvorfor Vælge EquiNord?</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-3xl text-emerald-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Ekspert Viden</h3>
                <p className="text-gray-600 text-sm">Årtiers kombineret hesteerfaring</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-price-tag-3-line text-3xl text-emerald-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Bedste Priser</h3>
                <p className="text-gray-600 text-sm">Direkte adgang til konkurrencedygtige priser</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Tidsbesparende</h3>
                <p className="text-gray-600 text-sm">Find alt hvad du har brug for på ét sted</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      </main>
      <Footer />
    </div>
  );
}
